import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import _noop from 'lodash/noop';

// Components
import FontIcon from '../../../atoms/FontIcon';
var SearchIcon = function SearchIcon(props) {
  var getStyles = props.getStyles;
  var style = getStyles('dropdownIndicator', props);
  var className = css(style);
  return /*#__PURE__*/React.createElement(FontIcon, {
    className: className
  }, "icon-search");
};
SearchIcon.propTypes = {
  getStyles: PropTypes.func
};
SearchIcon.defaultProps = {
  getStyles: _noop
};
export default SearchIcon;